import { ContentCardItem } from '@/lib/types/content';

export const CONTENT_CARD_PAGE_PER_COUNT = 10;

export const REFUND_ADVERTISEMENT_CARD: ContentCardItem[] = [
  {
    overText: '정호영 셰프도 신청 완료',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '5년치 정부 환급금 조회\n사업자 평균 960만원',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-refund-2',
    backgroundColorClass: 'bg-[#2f4bda]',
    complianceLogo: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/logos/logo-bznav-refund-white.svg`,
    link: 'https://ab.bznav.com/fecfsrc'
  },
  {
    overText: '전국 소상공인·사업자 대상',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '사업자 평균 960만원\n정부 환급금 신청 폭주 중!',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-refund-0',
    backgroundColorClass: 'bg-[#3a8cff]',
    complianceLogo: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/logos/logo-bznav-refund-white.svg`,
    link: 'https://ab.bznav.com/rs9jwz'
  },
  {
    overText: '사업자 평균 960만원',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '5년치 정부 환급금,\n오늘 지나면 사라져요!',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-refund-1',
    backgroundColorClass: 'bg-[#2f4bda]',
    complianceLogo: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/logos/logo-bznav-refund-white.svg`,
    link: 'https://ab.bznav.com/9prgk0'
  }
];

export const APP_ADVERTISEMENT_CARD: ContentCardItem[] = [
  {
    overText: '내 사업 오늘 잘될까?',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '오늘의 사업 운세를\n무료로 확인해보세요',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-app-0',
    backgroundColorClass: 'bg-[#f4f4ff]',
    link: 'https://abr.ge/0ub0zw?utm_source=sena&utm_campaign=sena_feedbanner&utm_medium=sena&utm_content=image_card_business.fortune.free_crystal.ball_pinkorange'
  },
  {
    overText: '쉬운 세무의 시작, 비즈넵',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '세무 기장·AI상담·환급까지,\n앱 하나로 편하게 해결하세요',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-app-1',
    backgroundColorClass: 'bg-[#f4f4ff]',
    link: 'https://abr.ge/heyko3e?utm_source=sena&utm_campaign=sena_feedbanner&utm_medium=sena&utm_content=image_card_one.app.convenient_bznav.logo_purple'
  },
  {
    overText: '쉬운 세무의 시작, 비즈넵',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '세무 고민 한번에 해결!\n사업자를 위한 필수 앱',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-app-2',
    backgroundColorClass: 'bg-[#f4f4ff]',
    link: 'https://abr.ge/heyko3e?utm_source=sena&utm_campaign=sena_feedbanner&utm_medium=sena&utm_content=image_card_business.essential.app_feature.icon_purpleblue'
  }
];

export const QUESTION_CARD_COLOR_CLASS: Pick<ContentCardItem, 'backgroundColorClass' | 'overTextColorClass' | 'titleColorClass'>[] = [
  { backgroundColorClass: 'bg-gray-100', overTextColorClass: 'text-gray-alpha-500', titleColorClass: 'text-neutral-foreground-main' },
  { backgroundColorClass: 'bg-blue-600', overTextColorClass: 'text-gray-alpha-inverse-500', titleColorClass: 'text-neutral-foreground-inverse-main' },
  { backgroundColorClass: 'bg-violet-100', overTextColorClass: 'text-gray-alpha-500', titleColorClass: 'text-neutral-foreground-main' },
  { backgroundColorClass: 'bg-gray-900', overTextColorClass: 'text-gray-alpha-inverse-500', titleColorClass: 'text-neutral-foreground-inverse-main' }
];

export const LOGO_EXPERTS: Record<string, string> = {
  지수회계법인: '/logos/expert/zsoo.svg',
  나이스노무법인: '/logos/expert/nice.svg',
  투모로법무사강남사무소: '/logos/expert/tomolaw.svg',
  카이특허법인: '/logos/expert/kai.svg',
  법무법인웨이브: '/logos/expert/wave.svg',
  변호사정선화법률사무소: '/logos/expert/sunhwa.png'
};

export const LOADING_TEXTS = ['세나가 최상의 답변을 준비 중이에요', '관련 조문과 판례, 사례를 찾고 있어요', '곧 답변 드릴게요! 조금만 기다려 주세요'];
